import { Injectable } from "@angular/core";
import { Address } from "../../models/entity/address";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError as observableThrowError, Observable, of } from "rxjs";
import { RequestCacheService } from "./request-cache.service";
import { BaseRestService } from "../base-rest.service";
import { SessionStorageService } from "../session-storage.service";

@Injectable({
  providedIn: "root"
})
export class AddressService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService, private cache: RequestCacheService) {
    super(httpClient, sessionStorageService);
  }

  getAddresses(): Observable<Address[]> {
    const url = `/addresses`;
    return this.httpGet<Address[]>(url).pipe(catchError(this.errorHandler));
  }

  getAddressById(id: number) {
    const url = `/addresses/${id}`;
    return this.httpGet(url).pipe(catchError(this.errorHandler));
  }

  addAddress(address) {
    const url = `/addresses`;
    return this.httpPost(url, address).pipe(catchError(this.errorHandler));
  }

  updateAddress(id, address): Observable<Address> {
    const url = `/addresses/${id}`;
    return this.httpPut<Address>(url, address)
      .pipe(catchError(this.errorHandler));
  }



  deleteAddress(id) {
    const url = `/addresses/${id}`;
    return this.httpDelete(url).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error);
  }
}
